import React, { memo } from "react";
import {
  areFilterPropsEqual,
  CustomStyleDynamicWidth,
  timeRange,
} from "../helper";
import Select from "react-select";
import { DateTime } from "luxon";
import { format } from "date-fns";
import CalendarPicker from "app/components/OptionButtonGroup/CalendarPicker";
import styles from "../styles.module.scss";
import { useTranslation } from "react-i18next";

const DateFilter = ({ title, value, onChange, options, queryName }) => {
  const { t } = useTranslation();
  const setPeriodValueQuery = (elem) => {
    const from_date = `${queryName}_start_date`;
    const to_date = `${queryName}_end_date`;
    const name = `${queryName}`;
    if (value[queryName] !== "custom" && elem === "custom") {
      const time_range = timeRange(value[queryName]);
      onChange({
        [name]: elem,
        [from_date]: time_range[0].toFormat("yyyy-MM-dd"),
        [to_date]: time_range[1].toFormat("yyyy-MM-dd"),
      });
    } else {
      const name = `${queryName}`;
      onChange({
        [name]: elem,
        [from_date]: null,
        [to_date]: null,
      });
    }
  };

  const setFromDateQuery = (selectedValue) => {
    const from_date = `${queryName}_start_date`;
    const to_date = `${queryName}_end_date`;
    const selectedFromDate = format(selectedValue, "yyyy-MM-dd");
    const currentToDate = value[to_date];

    const updateObj = { [from_date]: selectedFromDate };
    if (currentToDate && DateTime.fromISO(currentToDate).toJSDate() < DateTime.fromISO(selectedFromDate).toJSDate()) {
      updateObj[to_date] = selectedFromDate;
    }

    onChange(updateObj);
  };

  const setToDateQuery = (value) => {
    const to_date = `${queryName}_end_date`;
    onChange({ [to_date]: format(value, "yyyy-MM-dd") });
  };

  const handleChange = ({ value }) => {
    setPeriodValueQuery(value);
  };

  const getMinDateForTo = () => {
    const fromDate = value[`${queryName}_start_date`];
    return fromDate ? DateTime.fromISO(fromDate).toJSDate() : null;
  };

  const translatedOptions = options.map(option => {
    return { label: t(option.label), value: option.value };
  });

  return (
    <div className={styles.filter_container}>
      <div className={styles.title}>{t(title)}</div>
      <Select
        options={translatedOptions}
        isSearchable={false}
        value={translatedOptions.find((el) => el.value === value[queryName]) || null}
        components={{
          IndicatorSeparator: () => null,
        }}
        onChange={handleChange}
        styles={CustomStyleDynamicWidth}
      />
      {value[queryName] === "custom" ? (
        <div className={styles.custom_period_container}>
          <div className={styles.input_container}>
            <div>From:</div>
            <div className={styles.calendar_picker_container}>
              <CalendarPicker
                date={value[`${queryName}_start_date`]}
                setDate={setFromDateQuery}
                customInput={true}
              />
            </div>
          </div>
          <div className={styles.input_container}>
            <div className="">To:</div>
            <div className={styles.calendar_picker_container}>
              <CalendarPicker
                date={value[`${queryName}_end_date`]}
                setDate={setToDateQuery}
                customInput={true}
                minDate={getMinDateForTo()}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default memo(DateFilter, areFilterPropsEqual);
